import signalr from 'BASE/common/signalrAdapter';
import websiteInfoUtil from 'BASE/common/util/util.websiteInfo';
import userInfo_component from 'BASE/components/userInfo.component'; //權限等狀態初始化須使用
import BetAwardNotifyComponent from 'BASE/components/notification/betAwardNotify.component';
import { MouseParticle } from 'XH/common/MouseParticle'; 
import { browser } from 'BASE/common/util/util.browser'
import IEAlertComponent from 'XH/views/IEAlert.vue';
import StreamingNotificationComponent from 'XH/views/Notification/StreamingNotification.vue';
export default {
    mixins: [websiteInfoUtil, userInfo_component],
    data: function () {
        return {
            appClass: '',
            notificationCount: 1,                        
        }
    },
    components: {
        BetAwardNotifyComponent,
        IEAlertComponent,
        StreamingNotificationComponent
    },
    computed:{
        skinClass(){
            if(!this.CanUseSkin){
                return '';
            }
            return this.$store.state.userinfo.skinClass;
        },

        CanUseSkin(){
            let val = this.$route.name;
            let _skinHandle = ['Home','Bet','BetInput'];

            if( val != null && _skinHandle.find((item) => val==item )){
                return true;
            }
            return false;
        },

    },
    watch: {
        "$route.path": function (val, oldVal) {
            let _errorHandle = ['/Timeout','/Offline','/LinkFailure','/ErrorMsg','/IPRestricted'];
            if(_errorHandle.find((item) => val.indexOf(item) != -1)){
                this.appClass = "errorbody";
            }
            else {
                this.appClass = "";
            }
        }
    },
    methods:{
        MouseParticleInit(){
            MouseParticle.parametersInit();
            MouseParticle.setCanvasSize()
            MouseParticle.init();
            MouseParticle.windowEventInit();
        }
    },
    created() {
        let _this = this;
        signalr.init();
        window.addEventListener("load", function(){
            _this.MouseParticleInit();
        });
    },
    mounted() {
        if (browser.isIE)
            this.$refs.ieAlert.showDialog();

        let height = window.innerHeight;
        let notificatioTop = 20;
        let notificatioHeight = 130;
        let notificatioMustHeight = notificatioTop + notificatioHeight;
        if(height > notificatioMustHeight) {
            this.notificationCount = parseInt(height / notificatioMustHeight);
        }        
    },
};